import { render } from "./UsersList.vue?vue&type=template&id=8cddfa32&scoped=true&ts=true"
import script from "./UsersList.vue?vue&type=script&lang=ts"
export * from "./UsersList.vue?vue&type=script&lang=ts"

import "./UsersList.vue?vue&type=style&index=0&id=8cddfa32&scoped=true&lang=css"

import exportComponent from "/home/uat/uatdan_yrshop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cddfa32"]])

export default __exports__